import React from "react";

function SearchBar({ searchQuery, setSearchQuery }) {

  const handleChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const clearInput = () => {
    setSearchQuery("");
  };

  return (
    <div className="search-bar">

      <input
        type="text"
        placeholder="Search movies..."
        value={searchQuery}
        onChange={handleChange}
      />

      <button onClick={clearInput}>
        Reset
      </button>

    </div>
  );
}

export default SearchBar;